module.exports = __webpack_public_path__ + "img/14xlzkxt.f5468fc8.svg";